import {
  Alert,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import axios from 'axios';
import React from 'react';
import appConfig from '../app-config';
import { StubAuthenticator } from 'rmf-auth';

interface LoginPageProps {
  onLoginSuccess: (username: string) => void;
}

export function DashboardLoginPage({ onLoginSuccess }: LoginPageProps): JSX.Element {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setError(null);
    try {
      const resp = await axios.post(`${appConfig.rmfServerUrl}/auth/login`, {
        username,
        password,
      });
      const { username: loggedInUser } = resp.data;
      if (appConfig.authenticator instanceof StubAuthenticator) {
        appConfig.authenticator.setUser(loggedInUser);
      }
      onLoginSuccess(loggedInUser);
    } catch (err: unknown) {
      if (axios.isAxiosError(err) && err.response?.status === 401) {
        setError('Invalid username or password');
      } else {
        setError('Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack
      width="100vw"
      height="100vh"
      alignItems="center"
      justifyContent="center"
      bgcolor="primary.main"
    >
      <Card sx={{ width: 360 }}>
        <CardContent sx={{ p: 4 }}>
          <Stack alignItems="center" mb={3}>
            {/*<img src="assets/defaultLogo.png" alt="logo" style={{ height: 60 }} />*/}
            <Typography variant="h5" mt={1}>
              Dashboard
            </Typography>
          </Stack>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              margin="normal"
              autoFocus
            />
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              size="large"
              sx={{ mt: 2 }}
              disabled={loading || !username || !password}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Login'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Stack>
  );
}
